module.exports = __webpack_public_path__ + "img/create-campaign-img.a55db3c6.png";